<template>
  <div>
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Export Files (beta)' }"
      >
      Export Files
      </v-tab>
      <v-tab
        :to="{ name: 'Export Files (original)' }"
      >
      Export Files (Additional)
      </v-tab>
      <!-- TICKET-2778: only for counties with the Clerk system link set up -->
      <v-tab
        v-if="clerkLinkConfigured"
        :to="{ name: 'Export Files (Clerk system)' }"
      >
      Clerk System
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { clients } from '../../util/clients';

const { backendRest } = clients.direct;

export default {
  name: 'ExportFiles',
  components: {
  },
  data: () => ({
    clerkLinkConfigured: false,
  }),
  async created() {
    try {
      const { data } = await backendRest.get('/treasurer-link/config');
      this.clerkLinkConfigured = !!(data && data.configured);
    } catch (err) {
      this.clerkLinkConfigured = false;
    }
  },
};
</script>
